import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage';
import Layout from './components/Layout';
import ManageLocations from './components/ManageLocations/ManageLocationsPage';
import LocationDetails from './components/ManageLocations/LocationDetails/LocationDetailsPage';
import UploadLocationPage from './components/Upload/UploadLocationPage';
import BulkUploadPage from './components/Upload/BulkUploadPage';
import BulkUploadManagementPage from './components/Upload/BulkUploadManagementPage';
import ZoneDetails from './components/ManageLocations/ZoneDetails/ZoneDetailsPage';
import AddressDetails from './components/ManageLocations/AddressDetails/AddressDetailsPage';
import Unauthorized from "./components/Unauthorized";
import Onboard from './components/Onboard/OnboardPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ProtectedRoute } from './utils/ProtectedRoutes';
import { CompanyProvider } from './CompanyContext';
import CountriesTable from './components/StaticData/CountriesTable';
import StatesTable from './components/StaticData/StatesTable';
import CitiesTable from './components/StaticData/CitiesTable';
import UnlocodesTable from './components/StaticData/UnlocodesTable';
import JobTrackingPage from './components/Tracking/JobTrackingPage';

export default function App() {
  return (
    <Router>
      <CompanyProvider>
        <Routes>
          <Route path="/login" element={<Onboard />} />
          <Route
            path="*"
            element={
              <Layout>
                <ToastContainer />
                <Routes>
                  <Route path="/" element={<ProtectedRoute element={HomePage} />} />
                  <Route path="/locations" element={<ProtectedRoute element={ManageLocations} requiredPrivileges={['LOC_VIEW']} />} />
                  <Route
                    path="/locations/zones/:id"
                    element={<ProtectedRoute element={ZoneDetails} requiredPrivileges={['ZONE_VIEW']} />}
                  />
                  <Route
                    path="/locations/locations/:id"
                    element={<ProtectedRoute element={LocationDetails} requiredPrivileges={['LOC_VIEW']} />}
                  />
                  <Route
                    path="/locations/addresses/:id"
                    element={<ProtectedRoute element={AddressDetails} requiredPrivileges={['ADDRESS_VIEW']} />}
                  />
                  <Route path="/addresses" element={<ProtectedRoute element={ManageLocations} requiredPrivileges={['ADDRESS_VIEW']} />} />
                  <Route path="/zones" element={<ProtectedRoute element={ManageLocations} requiredPrivileges={['ZONE_VIEW']} />} />
                  <Route
                    path="/uploadLocation"
                    element={<ProtectedRoute element={UploadLocationPage} requiredPrivileges={['LOC_UPLOAD']} />}
                  />
                  <Route
                    path="/bulkUpload"
                    element={<ProtectedRoute element={BulkUploadPage} requiredPrivileges={['BULK_UPLOAD']} />}
                  />
                  <Route
                    path="/bulkUpload/management"
                    element={<ProtectedRoute element={BulkUploadManagementPage} requiredPrivileges={['BULK_UPLOAD']} />}
                  />
                  <Route path="/static/countries" element={<CountriesTable />} />
                  <Route path="/static/states" element={<StatesTable />} />
                  <Route path="/static/cities" element={<CitiesTable />} />
                  <Route path="/static/unlocodes" element={<UnlocodesTable />} />
                  <Route path="/unauthorized" element={<Unauthorized />} />
                  <Route path="/jobTracking" element={<JobTrackingPage />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </CompanyProvider>
    </Router>
  );
}
